<form [formGroup]="form">
  <div class="ida-wrapper">
    <div class="ida-filters">
      <div class="mb-1" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <div class="form-row align-items-end">
          <div class="col-6" [ngClass]="showCustomDatePicker ? 'col-xl-2' : 'col-xl-3'">
            <div class="form-group">
              <label translate>Signals</label>

              @if (isLoadingSignals()) {
                <span class="fa-solid fa-spinner fa-spin ml-2"></span>
              }
              <ng-select [items]="signals"
                         labelForId="signalSelect"
                         (change)="onSignalSelect()"
                         bindLabel="name"
                         bindValue="id"
                         [multiple]="true"
                         [closeOnSelect]="false"
                         formControlName="signals"
                         [placeholder]="'Select signals....' | translate">
                <ng-template ng-header-tmp>
                  <div class="form-row align-items-center">
                    <div class="col-6">
                      <button (click)="onSelectAll()" class="btn btn-outline-primary btn-sm btn-block" translate>Select
                        all
                      </button>
                    </div>
                    <div class="col-6">
                      <button (click)="onClearAll()" class="btn btn-outline-primary btn-sm btn-block" translate>Clear
                      </button>
                    </div>
                  </div>
                </ng-template>

                <ng-template ng-multi-label-tmp let-items="items">
                  @if (items.length > 0) {
                    <div class="ng-value">
                      <span class="ng-value-label">
                        <strong [innerHTML]="items.length"></strong>
                        <span translate>Signal(s) selected</span>
                      </span>
                    </div>
                  }
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <strong class="d-block">
                    @if (item.machineSignal) {
                      <span class="fa-solid fa-gear mr-1"
                            [title]="'Configured machine signal' | translate">
                      </span>
                    }
                    <span [innerHTML]="item.displayedText | translate"></span>
                  </strong>
                  <span class="d-block small text-muted" [innerHTML]="item.table"></span>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-6" [ngClass]="showCustomDatePicker ? 'col-xl-2' : 'col-xl-3'">
            <div class="form-group">
              <label translate>String</label>

              @if (isLoadingSignals()) {
                <span class="fa-solid fa-spinner fa-spin ml-2"></span>
              }
              <ng-select [items]="stringSignals"
                         (change)="onStringSignalChange()"
                         labelForId="stringSelect"
                         bindLabel="displayedText"
                         bindValue="id"
                         formControlName="stringSignal"
                         [placeholder]="'Select string ...' | translate">

                <ng-template ng-label-tmp let-item="item">
                  <span [innerHTML]="item.displayedText | translate"></span>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="row">
                    <div class="col">
                      <strong class="d-block" [innerHTML]="item.displayedText | translate"></strong>
                      <span class="d-block small text-muted" [innerHTML]="item.table"></span>
                    </div>
                    @if (item.machineSignal) {
                      <div class="col-auto">
                        <span class="fa-solid fa-gear" [title]="'Configured machine string' | translate"></span>
                      </div>
                    }
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg">
            <div class="form-row">
              <div class="col" [ngClass]="showCustomDatePicker ? 'col-5' : 'col'">
                <div class="form-group">
                  <label translate>Date & Time</label>
                  <ng-select
                      [items]="intervalTypes"
                      bindLabel="name"
                      bindValue="id"
                      [clearable]="false"
                      (change)="setIntervalType($event)"
                      formControlName="intervalType">
                    <ng-template ng-label-tmp let-item="item">
                      <span [innerText]="item.name | translate"></span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span [innerText]="item.name | translate"></span>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              @if (showCustomDatePicker) {
                <div class="col-7">
                  <div class="form-row">
                    <div class="col">
                      <scitis-date-time-picker
                          [textLabel]="startTimeLabel"
                          [showRequiredFieldIndicator]="false"
                          [startDate]="dateNow"
                          [startTime]="getStartTime()"
                          [showSeconds]="false"
                          (focusOut)="onFocusOutStartTime($event)">
                      </scitis-date-time-picker>
                    </div>
                    <div class="col">
                      <scitis-date-time-picker
                          [textLabel]="endTimeLabel"
                          [showRequiredFieldIndicator]="false"
                          [startDate]="dateNow"
                          [startTime]="getStartTime()"
                          [showSeconds]="false"
                          (focusOut)="onFocusOutEndTime($event)">
                      </scitis-date-time-picker>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-6 col-xl-auto">
            <div class="form-group">
              <label translate>Aggregation</label>
              <ng-select
                  [items]="possibleAggregationUnits"
                  bindLabel="label"
                  bindValue="name"
                  [clearable]="false"
                  style="min-width: 180px;"
                  (change)="setAggregationType($event.name)"
                  formControlName="aggregationType">
                <ng-template ng-label-tmp let-item="item">
                  <span [innerText]="item.label | translate"></span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span [innerText]="item.label | translate"></span>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="col-12 col-xl-auto">
            <button class="btn btn-primary btn-block mb-3" [disabled]="chartSettings.signals.length === 0"
                    (click)="update()" [title]="'Apply' | translate">
              <span class="fa-solid fa-arrows-rotate"></span>
              <span [innerText]="'Update' | translate"></span>
            </button>
          </div>
        </div>

      </div>
    </div>
    @if (this.unusableSignals.length > 0) {
      <div class="d-flex align-items-center justify-content-center m-0 mb-2 alert alert-warning text-center">
        <em class="fa-solid fa-circle-exclamation mr-2"></em>
        <span class="mr-2" translate>Following signals/aliases could not be found in BigQuery Table:</span>
        @for (signal of this.unusableSignals; track signal) {
          <span class="badge badge-pill badge-warning text-white"
                [innerHtml]="signal"></span>
        }
      </div>
    }
    <div class="ida-chart">
      <scitis-chart-area-range-with-line
          [chartSettings]="chartSettings"
          [machineId]="machineId"
          [machineSignals]="signals"
          [stringData]="originalStringData"
          [data]="aggregatedData"
          [chartId]="chartId"
          [exportFileName]="exportFileName"
          [exportFileType]="exportFileType">
      </scitis-chart-area-range-with-line>
    </div>

  </div>
</form>
